import React from "react";
import { DateTime } from "luxon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import styles from "./styles.scss";

const times = {
  "0h00": { hours: 0, minutes: 0 },
  "0h30": { hours: 0, minutes: 30 },
  "1h00": { hours: 1, minutes: 0 },
  "1h30": { hours: 1, minutes: 30 },
  "2h00": { hours: 2, minutes: 0 },
  "2h30": { hours: 2, minutes: 30 },
  "3h00": { hours: 3, minutes: 0 },
  "3h30": { hours: 3, minutes: 30 },
  "4h00": { hours: 4, minutes: 0 },
  "4h30": { hours: 4, minutes: 30 },
  "5h00": { hours: 5, minutes: 0 },
  "5h30": { hours: 5, minutes: 30 },
  "6h00": { hours: 6, minutes: 0 },
  "6h30": { hours: 6, minutes: 30 },
  "7h00": { hours: 7, minutes: 0 },
  "7h30": { hours: 7, minutes: 30 },
  "8h00": { hours: 8, minutes: 0 },
  "8h30": { hours: 8, minutes: 30 },
  "9h00": { hours: 9, minutes: 0 },
  "9h30": { hours: 9, minutes: 30 },
  "10h00": { hours: 10, minutes: 0 },
  "10h30": { hours: 10, minutes: 30 },
  "11h00": { hours: 11, minutes: 0 },
  "11h30": { hours: 11, minutes: 30 },
  "12h00": { hours: 12, minutes: 0 },
  "12h30": { hours: 12, minutes: 30 },
  "13h00": { hours: 13, minutes: 0 },
  "13h30": { hours: 13, minutes: 30 },
  "14h00": { hours: 14, minutes: 0 },
  "14h30": { hours: 14, minutes: 30 },
  "15h00": { hours: 15, minutes: 0 },
  "15h30": { hours: 15, minutes: 30 },
  "16h00": { hours: 16, minutes: 0 },
  "16h30": { hours: 16, minutes: 30 },
  "17h00": { hours: 17, minutes: 0 },
  "17h30": { hours: 17, minutes: 30 },
  "18h00": { hours: 18, minutes: 0 },
  "18h30": { hours: 18, minutes: 30 },
  "19h00": { hours: 19, minutes: 0 },
  "19h30": { hours: 19, minutes: 30 },
  "20h00": { hours: 20, minutes: 0 },
  "20h30": { hours: 20, minutes: 30 },
  "21h00": { hours: 21, minutes: 0 },
  "21h30": { hours: 21, minutes: 30 },
  "22h00": { hours: 22, minutes: 0 },
  "22h30": { hours: 22, minutes: 30 },
  "23h00": { hours: 23, minutes: 0 },
  "23h30": { hours: 23, minutes: 30 },
};

function getTimeDisplay(dateStr: string, zone: string): string {
  if (!dateStr) return "";
  const dt = DateTime.fromISO(dateStr, { zone: "utc" }).setZone(zone);
  if (!dt.isValid) return "";
  const h = dt.hour;
  const m = dt.minute;
  return `${h}h${m === 0 ? "00" : String(m).padStart(2, "0")}`;
}

function TimeInput({ value, input, position = "bottom", timezone }: Props) {
  const zone = timezone ?? DateTime.local().zoneName;
  const listStyle =
    position === "top"
      ? { top: "auto", bottom: "calc(100% + 1rem)" }
      : undefined;

  return (
    <SelectList<string>
      listClassName={styles.timeListWrapper}
      listStyle={listStyle}
    >
      {({ select }) => ({
        input: (
          <div className={styles.timeInput}>
            {value ? (
              <p className={styles.timeValue}>{getTimeDisplay(value, zone)}</p>
            ) : (
              <p className={styles.timePlaceholder}>--:--</p>
            )}
          </div>
        ),
        list: (
          <ul className={styles.timeList}>
            {Object.keys(times).map((key) => {
              const { hours, minutes } = times[key as keyof typeof times];
              return (
                <li
                  key={key}
                  className={styles.time}
                  onClick={() => {
                    const base = value
                      ? DateTime.fromISO(value, { zone: "utc" }).setZone(zone)
                      : DateTime.now().setZone(zone);
                    const next = base.set({
                      hour: hours,
                      minute: minutes,
                      second: 0,
                      millisecond: 0,
                    });
                    input(select(next.toUTC().toISO() ?? ""));
                  }}
                >
                  <p className={styles.timeName}>{key}</p>
                </li>
              );
            })}
          </ul>
        ),
      })}
    </SelectList>
  );
}

export { TimeInput };
